import Firebase from 'firebase/compat/app'
import ReactGA from 'react-ga'

const deleteDeployment = id => {

  ReactGA.event({
    category: 'Deployment',
    action: 'Delete deployment',
  })

  return Firebase.firestore()
    .collection('deployed')
    .doc(id)
    .delete()
    // .catch( error => {
    //   alert(`Whoops, couldn't delete the post: ${error.message}`)
    // })
}

export default deleteDeployment
